export const facetValueStates: FacetValueState[] = [
  'idle',
  'selected',
  'excluded',
];
export type FacetValueState = 'idle' | 'selected' | 'excluded';
